import {Catalog} from '../../common/types/common';

export const defaultCatalog = {id: '', value: ''};

export const hasErrorPersonalDataFields = (firstNameFieldError: string,
                                           lastNameFieldError: string,
                                           secondLastNameFieldError: string,
                                           birthDateFieldError: string,
                                           docNumberFieldError: string,
                                           cellPhoneFieldError: string,
                                           genderFieldError: string,
                                           civilStatusFieldError: string,
                                           studiesLevelFieldError: string,
                                           economicDependentsFieldError: string,
                                           alreadyHasVehicleFieldError: string,
                                           nationalityFieldError: string) => {
    return firstNameFieldError == null &&
        lastNameFieldError == null &&
        secondLastNameFieldError == null &&
        birthDateFieldError == null &&
        docNumberFieldError == null &&
        cellPhoneFieldError == null &&
        genderFieldError == null &&
        civilStatusFieldError == null &&
        studiesLevelFieldError == null &&
        economicDependentsFieldError == null &&
        alreadyHasVehicleFieldError == null &&
        nationalityFieldError == null;
};

export const workDataFieldHasError = (
    workplaceNameFieldError: string,
    positionFieldError: string,
    workingSinceFieldError: string,
    addressFieldError: string,
    extNumberFieldError: string,
    postalCodeFieldError: string,
    stateFieldError: string,
    cityFieldError: string,
    municipalityFieldError: string,
    colonyFieldError: string,
    workplacePhoneFieldError: string,
    monthlyIncomesFieldError: string,
    includeMonthlyIncomes: boolean
) => {
    return workplaceNameFieldError == null &&
        positionFieldError == null &&
        workingSinceFieldError == null &&
        addressFieldError == null &&
        extNumberFieldError == null &&
        postalCodeFieldError == null &&
        stateFieldError == null &&
        cityFieldError == null &&
        municipalityFieldError == null &&
        colonyFieldError == null &&
        workplacePhoneFieldError == null &&
        (!includeMonthlyIncomes || (includeMonthlyIncomes && monthlyIncomesFieldError == null));
};

export const hasNotErrorHomeDataFields = (addressFieldError: string,
                                          extNumberFieldError: string,
                                          postalCodeFieldError: string,
                                          stateFieldError: string,
                                          municipalityFieldError: string,
                                          selectedColonyFieldError: string,
                                          phoneFieldError: string,
                                          monthlyIncomesFieldError: string,
                                          includeMonthlyIncomes: boolean,
                                          houseHoldMeasureFieldError: string,
                                          houseHoldTimeFieldError: string,
                                          houseTypeFieldError: string,
                                          documentTypeFieldError: string,
                                          businessTypeFieldError: string,
                                          workingSinceFieldError: string,
                                          billingTypeFieldError: string,
                                          relationshipTypeIdFieldError: string,
                                          taxRegimeFieldError: string,
                                          ) => {

    return addressFieldError === null &&
        extNumberFieldError === null &&
        postalCodeFieldError === null &&
        stateFieldError === null &&
        municipalityFieldError === null &&
        selectedColonyFieldError === null &&
        phoneFieldError === null &&
        houseHoldMeasureFieldError == null &&
        houseHoldTimeFieldError == null &&
        houseTypeFieldError == null &&
        documentTypeFieldError == null &&
        businessTypeFieldError == null &&
        workingSinceFieldError == null &&
        (!includeMonthlyIncomes || (includeMonthlyIncomes && monthlyIncomesFieldError == null) &&
        billingTypeFieldError == null &&
        relationshipTypeIdFieldError == null &&
        taxRegimeFieldError == null
    );
};

export const getCatalogValue = (catalog: Catalog) => {
    return catalog ? catalog.value : '';
};

export const hasCalculatorFieldsError = (yearFieldError: string,
                                         brandFieldError: string,
                                         modelFieldError: string,
                                         versionFieldError: string,
                                         postalCodeFieldError: string,
                                         priceFieldError: string,
                                         downPaymentFieldError: string,
                                         monthlyPaymentFieldError: string,
                                         assemblyCountryFieldError: string) => {
    return yearFieldError == null &&
        brandFieldError == null &&
        modelFieldError == null &&
        versionFieldError == null &&
        postalCodeFieldError == null &&
        priceFieldError == null &&
        downPaymentFieldError == null &&
        monthlyPaymentFieldError == null &&
        assemblyCountryFieldError == null;
};
